import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import {exportReport, organisationDetails, saveOrUpdateOrganisationDetails} from "../../util/ApiUtils";
import {NotificationContainer, NotificationManager} from "react-notifications";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {GreenButton} from "../common/ButtonsConstants";
import {SystemUpdateAltTwoTone} from "@material-ui/icons";
import * as CommonUtils from "../../util/CommonUtils";
import { t } from '../../i18n';

const top = 50;
const left = 50;

const classes = (theme => ({

    paper: {
        position: 'absolute',
        width: 800,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    },
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
        marginTop: "40px",
    },
}));

class InterestedParties extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            organisation: null,
            orgId: "",
            regulators: "",
            staff: "",
            customers: "",
            investors: "",
            management: "",
            employees: "",
            environment: "",
            community: "",
            suppliers: "",
            other: "",
        };
        this.export = this.export.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    export() {
        exportReport('/organisation/export/INTERESTED_PARTIES');
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log(response);
                this.setState({
                    organisation: response,
                    orgId: response.id,
                    regulators: response.regulators || '',
                    staff: response.staff || '',
                    customers: response.customers || '',
                    investors: response.investors || '',
                    management: response.management || '',
                    employees: response.employees || '',
                    environment: response.environment || '',
                    community: response.community || '',
                    suppliers: response.suppliers || '',
                    other: response.other || '',
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    showModal() {
        this.setState({ show: true });
    }

    closeModal() {
        this.setState({
            show: false,
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        console.log("Submitted");
        const organisationDetailsRequest = Object.assign(this.state.organisation,
            {
                id: this.state.orgId,
                regulators: this.state.regulators,
                staff: this.state.staff,
                customers: this.state.customers,
                investors: this.state.investors,
                management: this.state.management,
                employees: this.state.employees,
                environment: this.state.environment,
                community: this.state.community,
                suppliers: this.state.suppliers,
                other: this.state.other,
            }
        );
        console.log(organisationDetailsRequest);
        saveOrUpdateOrganisationDetails(organisationDetailsRequest)
            .then(() => {
                NotificationManager.success(t('app.notifications.success'), t('context.interested.updatedSuccess'), 5000);
                this.closeModal();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('context.interested.error'), 5000);
        });
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    render() {
        let { state } = this;
        const { classes } = this.props;
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                {t('context.interested.title')}
            </Typography>
            {!isDemo && !isViewer && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={this.export} style={{ float: 'right' }}>{t('context.interested.export')}</GreenButton>}
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <tr>
                            <th style={{ textAlign: 'left', paddingLeft: '16px' }}>{t('context.interested.columns.party')}</th>
                            <th style={{ textAlign: 'left', paddingLeft: '16px' }}>{t('context.interested.columns.overview')}</th>
                        </tr>
                    </TableHead>
                    <TableBody>
                        <TableRow key='regulators'>
                            <TableCell component="td" scope="row">
                                {t('context.interested.parties.regulators')}
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.regulators ? state.regulators : <b>{t('context.interested.placeholders.regulators')}</b>}</TableCell>
                        </TableRow>
                        <TableRow key='staff'>
                            <TableCell component="td" scope="row">
                                {t('context.interested.parties.staff')}
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.staff ? state.staff : <b>{t('context.interested.placeholders.staff')}</b>}</TableCell>
                        </TableRow>
                        <TableRow key='customers'>
                            <TableCell component="td" scope="row">
                                {t('context.interested.parties.customers')}
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.customers ? state.customers : <b>{t('context.interested.placeholders.customers')}</b>}</TableCell>
                        </TableRow>
                        <TableRow key='investors'>
                            <TableCell component="td" scope="row">
                                {t('context.interested.parties.investors')}
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.investors ? state.investors : <b>{t('context.interested.placeholders.investors')}</b>}</TableCell>
                        </TableRow>
                        <TableRow key='management'>
                            <TableCell component="td" scope="row">
                                {t('context.interested.parties.management')}
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.management ? state.management : <b>{t('context.interested.placeholders.management')}</b>}</TableCell>
                        </TableRow>
                        <TableRow key='employees'>
                            <TableCell component="td" scope="row">
                                {t('context.interested.parties.employees')}
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.employees ? state.employees : <b>{t('context.interested.placeholders.employees')}</b>}</TableCell>
                        </TableRow>
                        <TableRow key='environment'>
                            <TableCell component="td" scope="row">
                                {t('context.interested.parties.environment')}
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.environment ? state.environment : <b>{t('context.interested.placeholders.environment')}</b>}</TableCell>
                        </TableRow>
                        <TableRow key='community'>
                            <TableCell component="td" scope="row">
                                {t('context.interested.parties.community')}
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.community ? state.community : <b>{t('context.interested.placeholders.community')}</b>}</TableCell>
                        </TableRow>
                        <TableRow key='suppliers'>
                            <TableCell component="td" scope="row">
                                {t('context.interested.parties.suppliers')}
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.suppliers ? state.suppliers : <b>{t('context.interested.placeholders.suppliers')}</b>}</TableCell>
                        </TableRow>
                        <TableRow key='other'>
                            <TableCell component="td" scope="row">
                                {t('context.interested.parties.other')}
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.other ? state.other : <b>{t('context.interested.placeholders.other')}</b>}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={state.show}
                onClose={this.closeModal}
            >
                <div className={classes.paper}>
                    <Typography component="h2" variant="h5">{t('context.interested.modalTitle')}</Typography>
                    <form onSubmit={this.handleSubmit} className={classes.form}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="regulators"
                            label={t('context.interested.parties.regulators')}
                            name="regulators"
                            value={state.regulators}
                            autoFocus
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="staff"
                            label={t('context.interested.parties.staff')}
                            name="staff"
                            value={state.staff}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="customers"
                            label={t('context.interested.parties.customers')}
                            name="customers"
                            value={state.customers}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="investors"
                            label={t('context.interested.parties.investors')}
                            name="investors"
                            value={state.investors}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="management"
                            label={t('context.interested.parties.management')}
                            name="management"
                            value={state.management}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="employees"
                            label={t('context.interested.parties.employees')}
                            name="employees"
                            value={state.employees}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="environment"
                            label={t('context.interested.parties.environment')}
                            name="environment"
                            value={state.environment}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="community"
                            label={t('context.interested.parties.community')}
                            name="community"
                            value={state.community}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="suppliers"
                            label={t('context.interested.parties.suppliers')}
                            name="suppliers"
                            value={state.suppliers}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="other"
                            label={t('context.interested.parties.other')}
                            name="other"
                            value={state.other}
                            onChange={ this.handleChange }
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                        >
                            {t('context.interested.submit')}
                        </Button>
                    </form>
                </div>
            </Modal>
            <Button
                onClick={this.showModal}
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                disabled={isAuditor || isViewer}
            >
                {t('context.interested.edit')}
            </Button>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(InterestedParties);